import { useState, useEffect, useCallback } from 'react';
import { fetchApi } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export function useCompanyProfile() {
  const { user, role } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    if (!user || (role !== 'company' && role !== 'pending_company' && role !== 'admin')) {
      setLoading(false);
      return;
    }
    try {
      const data = await fetchApi('/api/company-profile');
      setProfile(data.profile);
    } catch (err) {
      console.error('Failed to load company profile:', err);
    } finally {
      setLoading(false);
    }
  }, [user, role]);

  useEffect(() => { load(); }, [load]);

  const save = useCallback(async (updates) => {
    setSaving(true);
    try {
      const data = await fetchApi('/api/company-profile', {
        method: 'POST',
        body: JSON.stringify(updates),
      });
      setProfile(data.profile);
      return data.profile;
    } catch (err) {
      console.error('Failed to save company profile:', err);
      throw err;
    } finally {
      setSaving(false);
    }
  }, []);

  return { profile, loading, saving, save, refresh: load };
}
